const ITEMS_PER_HALF = 6;

const Separator = () => (
  <span aria-hidden="true" className="mx-6 inline-flex h-2 w-2 rotate-45 rounded-[1px] bg-lime sm:mx-9" />
);

const BrandText = () => (
  <span className="whitespace-nowrap font-display text-[13px] font-extrabold uppercase tracking-[0.34em] text-white sm:text-sm">
    Sania Job Bowl
  </span>
);

export default function BrandMarquee() {
  return (
    <div
      data-testid="brand-banner-marquee"
      className="fixed inset-x-0 top-0 z-[70] h-10 overflow-hidden bg-royal shadow-[0_1px_0_rgba(182,212,54,0.55),0_8px_24px_-12px_rgba(12,20,64,0.5)]"
      role="banner"
      aria-label="Sania Job Bowl"
    >
      <div className="marquee-track h-full">
        {[0, 1].map((half) => (
          <div key={half} aria-hidden={half === 1 || undefined} className="marquee-half">
            {Array.from({ length: ITEMS_PER_HALF }).map((_, i) => (
              <span key={i} className="flex items-center">
                <BrandText />
                <Separator />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
